import { ActionTypes } from '../constants/ActionTypes';

const initialState = [];

const projects = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_PROJECTS:
            return setProjects(state, action);
    }

    return state;
}

function setProjects(state, action) {
    const projects = action.projects ? action.projects : state;

    return projects;
}

const initialcurProjectID = 0;
const curProjectID = (state = initialcurProjectID, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_PROJECT:
            return setCurrentProject(state, action);
    }

    return state;
}

function setCurrentProject(state, action) {
    const projectID = action.projectID;
    return projectID;
}

export { projects, curProjectID };


// WEBPACK FOOTER //
// ./src/reducers/projects.js